import { createEntityAdapter } from '@ngrx/entity';
import { OrganisationEntityState } from '@get/api-interfaces';
import { CustomEntityState } from '@get/store/configs/states';

export type IState = CustomEntityState<OrganisationEntityState>;

export const adapter = createEntityAdapter<OrganisationEntityState>({
  selectId: o => o.idOrganisation
});
export const initialState: IState = adapter.getInitialState({
  isLoaded: false,
  isLoading: false,
  actives: []
});

export const organisationFeatureKey = 'organisation';
